//@flow
// External
import React from 'react';
import { useRoutes } from 'raviger';

// Routes
import RouteConfig from './utils/routes';

// Styles
//$FlowFixMe
import './App.scss';

// Permit hosting at /competible relative path
const basePath = window.location.hostname.indexOf('rspcansw.org.au') > -1 ? '/competible' : '';

// App HOC
const App = () => {
	const Routes = useRoutes(RouteConfig, { basePath: basePath });
	return (
		<div className='App'>
			{Routes}
			<div id="popUpWindow"></div>
		</div>
	);
};

// Exports
export default App;
